

  export const COACH_CONFIG = {
    coachUserId: 'EoAnRHZsXFYhJQi58JWIZrkatzg1',
    coachName: 'Dr Olu',
    gymName: 'Elyte Fitness',
    apiBaseUrl: 'https://kinos-api.onrender.com/api'
  };
  
  // You can add more coach-specific configuration here
  export const COACH_DETAILS = {
    name: 'Dr Olu',
    email: 'olu@elyte-fitness.com',
    location: 'USA',
    specialties: ['Fat Loss', 'Form & Alignment', 'PHYT Method', 'Nutrition Coaching'],
    experience: '10+ years',
    clientsTrained: '500+',
    successRate: '95%'
  }; 

//   // Coach Configuration
// export const COACH_CONFIG = {
//     coachUserId: 'rbRrF12GFMcjJwAbWvx3it6tYrU2',
//     coachName: 'Davies KinOS',
//     gymName: 'Elyte Fitness',
//     apiBaseUrl: 'https://kinos-api.onrender.com/api'
//     // apiBaseUrl: 'http://localhost:3001/api'
//   };
  
//   // You can add more coach-specific configuration here
//   export const COACH_DETAILS = {
//     name: 'Davies KinOS',
//     email: 'davies@usekinos.com',
//     location: 'USA',
//     specialties: ['Fat Loss', 'Form & Alignment', 'PHYT Method', 'Nutrition Coaching'],
//     experience: '10+ years',
//     clientsTrained: '500+',
//     successRate: '95%'
//   }; 